import { useEffect, useState } from "react";
import { CatchmentRequest } from "@/app/catchment/catchment.types";
import TableComponent from "./TableComponent";
import { Formik } from "formik";

import {
  useGetAbsencesQuery,
} from "@/app/kpi/kpi.api";

export const initialValues: CatchmentRequest = {
  search: "",
  branch_filter: null,
  sex_filter: null,
  campaign_filter: null,
  stages_filter: null,
  stages_users_filter: null,
  tag_marketing_filter: null,
  catchment_page: "campaigns",
};

export const AbsencesPage = () => {
  const [formValues, setFormValues] = useState(initialValues);
  const catchmentQuery = useGetAbsencesQuery(formValues);

  const [people, setPeople] = useState([]);

  useEffect(() => {
    if (catchmentQuery.isSuccess) {
      const transformedData = catchmentQuery.data.users.map(
        (user: any) => ({
          name: user.name,
          email: user.email,
          phone: user.phone || "",
          company: `${user.gym}/${user.branch_id}`,
          diffDay: `${user.date_difference} Días`,
          lastAccess: user.created_date,
          avatar: user.avatar,
          campaign:
            catchmentQuery.data.bells?.find(
              (bell: any) =>
                bell.id === catchmentQuery.data.users[0].campaign_id
            )?.name || "",
          date: user.created_at,
          task: user.notes || "",
          dateTask: user.updated_at,
          businessStage: user.stages,
          labels: user.tag_marketing ? [user.tag_marketing] : [],
        })
      );

      setPeople(transformedData);
    }

    if (catchmentQuery.isError) {
      alert("Ocurrió un error");
    }
  }, [catchmentQuery]);

  return (
    <Formik
      initialValues={initialValues}
      validate={setFormValues}
      onSubmit={() => {}}
    >
      {({ values, setFieldValue }) => {
        return (
          <div className="flex-1 overflow-hidden px-10">
            <div className="mt-1">
              {values.catchment_page === "campaigns" && (
                <TableComponent
                  isLoading={catchmentQuery.isLoading}
                  isError={catchmentQuery.isError}
                  people={people}
                />
              )}
            </div>
          </div>
        );
      }}
    </Formik>
  );
};
